import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Arbitro } from './arbitros.model';
import { Colegiacion, Idioma, Nacionalidad, Profesion, Sector, SistemaJuridico, Ciudad } from './varios.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class ArbitrosService {

  private arbitrosURL: string = urlJoin(environment.apiURL, 'usuarios') // Los arbitros son usuarios con es_arbitro = true
  private variosURL: string = urlJoin(environment.apiURL, 'varios')


  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getArbitros(): Observable<Arbitro[]> {
    return this.http.get<Arbitro[]>(this.arbitrosURL+'?nivel_acceso=USUARIO&es_arbitro=true')
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getArbitro(id: string): Observable<Arbitro> {
    const getArbitroURL = urlJoin(this.arbitrosURL, id)
    return this.http.get<Arbitro>(getArbitroURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateArbitro(id: string, arbitro: Arbitro): Observable<any> {
    const updateArbitroURL = urlJoin(this.arbitrosURL, id)
    return this.http.put<Arbitro>(updateArbitroURL, arbitro)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateAvatar(id: string, avatar: FormData): Observable<any> {
    const updateAvatarURL = urlJoin(this.arbitrosURL, id, "/foto");
    return this.http.put<Arbitro>(updateAvatarURL, avatar)
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getAvatar(id: string): Observable<any> {
    const getAvatarURL = urlJoin(this.arbitrosURL, id, "/descargarFoto");
    return this.http.get(getAvatarURL, { responseType: 'blob' }) // Aquí está el cambio clave
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }


  deleteArbitro(id: string | number): Observable<any> {
    const empleadoURL = urlJoin(this.arbitrosURL, id.toString())
    return this.http.delete<Arbitro>(empleadoURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateArbitroEstado(id: string, accion: 'ACTIVAR' | 'DESACTIVAR'): Observable<any> {
    const updateArbitroEstadoURL = urlJoin(this.arbitrosURL, id, 'estado');
    return this.http.put<Arbitro>(updateArbitroEstadoURL, { accion })
      .pipe(
        tap(() => { }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getNacionalidades(): Observable<Nacionalidad[]> {
    let nacionalidadesURL = this.variosURL + "/nacionalidades"
    return this.http.get<Nacionalidad[]>(nacionalidadesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getColegiaciones(): Observable<Colegiacion[]> {
    let colegiacionesURL = this.variosURL + "/colegiaciones"
    return this.http.get<Colegiacion[]>(colegiacionesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getProfesiones(): Observable<Profesion[]> {
    let profesionesURL = this.variosURL + "/profesiones";
    return this.http.get<Profesion[]>(profesionesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getIdiomas(): Observable<Idioma[]> {
    let idiomasURL = this.variosURL + "/idiomas";
    return this.http.get<Idioma[]>(idiomasURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getSectores(): Observable<Sector[]> {
    let sectoresURL = this.variosURL + "/sectores";
    return this.http.get<Sector[]>(sectoresURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getCiudades(): Observable<Ciudad[]> {
    let ciudadesURL = this.variosURL + "/ciudades";
    return this.http.get<Ciudad[]>(ciudadesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }

  getSistemasJuridicos(): Observable<SistemaJuridico[]> {
    let sistemasJuridicosURL = this.variosURL + "/sistemasJuridicos";
    return this.http.get<SistemaJuridico[]>(sistemasJuridicosURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error);
        })
      );
  }
}
